export const state = {
  province: [],
};
